var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSidebar)?_c('v-modal',{attrs:{"vertical":"","modal-class":"navigation-page-modal"},on:{"close":_vm.toggleSidebar}},[_c('template',{slot:"#pages"},[_c('tabbar-content')],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }